import { Grid } from "@mui/material";
import { MeasureDrillDownInfo } from "../../../../../api/biApi.types";
import { DrillDownPage } from "../../../../../store/types/drillDownPageState.types";
import LedgerPart from "./LedgerPart";

interface Props {
  configuration: DrillDownPage;
  info: MeasureDrillDownInfo;
}

export default function LedgerPage({ configuration, info }: Props) {
  return (
    <Grid container sx={{ flex: 1, width: "100%" }}>
      <LedgerPart configuration={configuration} info={info} />
    </Grid>
  );
}
